<template>
  <div class="fill-height">
    <WallHeader
      :declaredDistance="declaredDistance"
      :p-facebook="facebook"
      :p-hashtag="hashtag"
      :p-instagram="instagram"
      :p-twitter="twitter"
      :team="team"
      :teamMode="teamMode"
      :isRunning="activity && activity.isRunning"
    />
    <v-container fluid>
      <WallContent v-if="selfies" :p-hashtag="hashtag" :selfies="selfies.items" v-bind:expanded="expanded" />
    </v-container>
  </div>
</template>

<script>
import WallHeader from "./components/WallHeader";
import WallContent from "./components/WallContent";

export default {
  name: "wall",
  components: { WallContent, WallHeader },
  props: {
    activityId: {
      type: Number,
      default: null,
      required: false,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
    hashtag: String,
    facebook: String,
    instagram: String,
    twitter: String,
  },
  data() {
    return {
      selfies: null,
      getSelfiesIntervalId: null,
      resolvedActivityId: null,
      activitySlug: null,
      teamSlug: null,
      activity: null,
      teamMode: false,
      team: null,
      declaredDistance: null,
    };
  },
  async mounted() {
    this.resolvedActivityId = this.activityId || this.$route.params["activityId"];
    this.activitySlug = this.$route.params["activitySlug"];
    this.teamSlug = this.$route.params["teamSlug"];

    if (!this.activitySlug) {
      this.activitySlug = (await this.$axios.get(`/event/activities/${this.resolvedActivityId}`)).slug;
    }
    this.activity = await this.$axios.get(`/event/activities/slug/${this.activitySlug}`);
    this.$store.commit("ADD_ACTIVITY", this.activity);
    this.selectTheme();

    if (this.teamSlug != null) {
      this.teamMode = true;
      this.team = await this.$axios.get(`/event/${this.activity.event.id}/teams/slug/${this.teamSlug}`);
      let declaredDistanceObj = await this.$axios.get(
        `/event/activities/${this.activity.id}/getTotalDeclaredDistance/${this.teamSlug}`
      );
      this.declaredDistance = declaredDistanceObj[0].totalDeclaredDistance;
    }

    await this.getSelfies();
    if (!this.getSelfiesIntervalId) this.getSelfiesIntervalId = setInterval(this.getSelfies, 30000);
  },
  beforeDestroy() {
    clearInterval(this.getSelfiesIntervalId);
    this.getSelfiesIntervalId = null;
  },
  methods: {
    async getSelfies() {
      if (this.teamMode === true) {
        this.selfies = await this.$axios.get(
          `event/${this.activity.id}/selfies.json1?orderDesc=true&includeMiniatures=true&includeTeamNameAndLogo=true&teamSlug=${this.teamSlug}`
        );
      } else {
        this.selfies = await this.$axios.get(
          `event/${this.resolvedActivityId}/selfies.json1?orderDesc=true&includeMiniatures=true&includeTeamNameAndLogo=true`
        );
      }
    },
    selectTheme() {
      this.$vuetify.theme.themes[this.activity.event.brandingTheme].primary = this.activity.event.brandingMainColor;
      this.$vuetify.theme[this.activity.event.brandingTheme] = true;
    },
  },
};
</script>

<style lang="scss">
body {
  height: 100vh;
}

#app {
  min-height: 100vh;
}
</style>
